import styled from '@emotion/styled';
import Icon from "patient-ping-remedy/packages/icon";

export const StyledUploadIcon = styled(Icon)`
  margin-right: 10px;
  font-size: 18px;
`;

export const NameWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PrintFormStyles = `
  <style>
    @media print {
      @page {
        margin: 30px;
      }
      
      title {
        display: none;
      }
    }
    
    body {
      margin: 30px;
      font-family: 'Libre Franklin', sans-serif
    }
    
    h2 {
      margin-bottom: 36px;
    }
      
    .heading {
      margin: 24px 0 12px 0;
    }
    
    .value {
      margin: 0;
    }
    
    .question-block {
      page-break-inside: avoid;
    }
  </style>
`;
